export default "__VITE_ASSET__CRWBmRNV__"